import { Box, Typography } from '@mui/material';
import DoneIcon from 'assets/icons/DoneIcon';

interface SelectableItemProps {
  title: string;
  icon?: string;
  isSelected: boolean;
  onSelect: () => void;
}

const SelectableItem = ({ title, icon, isSelected, onSelect }: SelectableItemProps) => {
  return (
    <Box
      onClick={onSelect}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 2,
        py: 1,
        height: 40,
        backgroundColor: isSelected ? 'background.default' : 'bgSwitch',
        borderRadius: 2,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'background.default',
        },
      }}>
      {icon && (
        <Box
          component='img'
          src={icon}
          sx={{
            display: 'block',
            height: 14,
            width: 20,
            mr: 2.2,
          }}
        />
      )}
      <Typography variant='body16rg'>{title}</Typography>
      <Box flex={1} />
      {isSelected && (
        <DoneIcon
          sx={{
            backgroundColor: 'blue',
            color: '#fff',
            borderRadius: '50%',
            width: 24,
            height: 24,
            padding: 0.5,
          }}
        />
      )}
    </Box>
  );
};

export default SelectableItem;
